import React from 'react';
import Menu from '@mui/material/Menu';
import AvatarActionsMenuItem from '@mui/material/MenuItem';

export {
  AvatarActionsMenuItem
};

type ExpectedChildProps = {
  onClick: (e: React.MouseEvent) => void;
};

export type AvatarActionsMenuProps = {
  button: React.ReactElement;
  children: React.ReactElement<ExpectedChildProps>[];
};


export const AvatarActionsMenu: React.FC<AvatarActionsMenuProps> = ({ button, children }) => {
  const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {React.cloneElement(button, { ...button.props, onClick: handleClick })}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {React.Children.map<React.ReactNode, React.ReactElement<ExpectedChildProps>>(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              onClick: (e: React.MouseEvent) => {
                child.props?.onClick?.(e);
                handleClose();
              }
            });
          }

          return null;
        })}
      </Menu>
    </>
  );
};
